import BaseApi from '@/api/controller/base';

const OFFICE_API_URL = 'office/';

class OfficeApi extends BaseApi {
  constructor() {
    super(OFFICE_API_URL);
  }

  get(id) {
    return this.api.get(`${id}`);
  }

  upsert(office) {
    const officeId = office.id || '';
    return this.api.post(`${officeId}`, office);
  }

  getGridData(params) {
    return this.api.post('gridData', params);
  }

  syncWithZoho() {
    return this.api.post('syncWithZoho');
  }
}

const apiInstance = new OfficeApi();
export { OfficeApi, apiInstance };
export default apiInstance;
